import axios from "axios";
import Config from "../utils/Config";
const BASE_URL = `${Config.API_BASE_URL}/admin`;
const GENERAL_INSURANCE_URL = `${Config.API_BASE_URL}`;

class InsurancePolicyService {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      },
    };
  }

  async getInsurancePolicies() {
    try {
      const response = await axios.get(
        `${BASE_URL}/policy/get`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message:
          response.data.data?.reason ||
          "Insurance policies fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while getting insurance policies",
      };
    }
  }

  async getProviderPolicies(provider_slug) {
    try {
      const response = await axios.get(
        `${BASE_URL}/provider_policies/${provider_slug}`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message:
          response.data.data?.reason ||
          "Provider policies fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while getting provider policies",
      };
    }
  }

  async getInsurancePolicy(policy_slug) {
    try {
      const response = await axios.get(
        `${GENERAL_INSURANCE_URL}/show/policy/${policy_slug}`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message:
          response.data.data?.reason || "Insurance policy fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while getting insurance policy",
      };
    }
  }

  async approvePolicy(policyId) {
    try {
      const response = await axios.post(
        `${BASE_URL}/policy/approve/${policyId}`,
        {},
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message:
          response.data.data?.reason || response.data?.message || "Policy approved successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while approving policy",
      };
    }
  }

  async rejectPolicy(policyId, rejectReason) {
    try {
      const response = await axios.post(
        `${BASE_URL}/policy/reject/${policyId}`,
        { reject_reason: rejectReason },
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message:
          response.data.data?.reason || response.data?.message || "Policy rejected successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while rejecting policy",
      };
    }
  }
}
const insurancePolicyService = new InsurancePolicyService();
export default insurancePolicyService;
